import React from 'react'
import {PageTitle} from '../../Molecules/BaseMembersPages/PageTitle'
import {ErrorSummary} from '../../Molecules/ErrorsAndAlert/ErrorSummary/ErrorSummary'
import {MembersPageTemplate, MembersPageTemplateProps} from '../../Molecules/BaseMembersPages/MembersPageTemplate'
import {PIMPageActions} from '../../Atoms/Layouts/PIMPageActions'
import {ExternalLinkButton} from '../../Atoms/Buttons'
import {Spacer} from '../../../../Common/Components/Spacer'

type MembersBaseErrorPageProps = Pick<MembersPageTemplateProps, 'bucketInfo'> & {
  pageTitle: string
  errorSummaryHeadLine: string
  errorSummaryDetail: string
  errorSummaryAreaTestId: string
  buttonName?: string
  url?: string
}

export const MembersBaseErrorPage: React.VFC<MembersBaseErrorPageProps> = (
  {
    bucketInfo,
    pageTitle,
    errorSummaryHeadLine,
    errorSummaryDetail,
    errorSummaryAreaTestId,
    buttonName,
    url,
  },
) => {
  return (
    <MembersPageTemplate
      hideFooterNavi={true}
      bucketInfo={bucketInfo}
    >
      <PageTitle>{pageTitle}</PageTitle>
      <ErrorSummary
        display={true}
        headline={errorSummaryHeadLine}
        detail={errorSummaryDetail}
        testId={errorSummaryAreaTestId}
      />

      <Spacer mt={'30px'}>
        <PIMPageActions>
          <ExternalLinkButton
            label={`${buttonName ?? ''}に移動する`}
            url={url}
          />
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}
